import { nanoid } from 'nanoid';
import { useCallback } from 'react';
import { useAuthManager, useMetrikaService } from '@funtech-int/yango-shared';

export const useMovieBuyButtonClickHandler = () => {
    const { isAuthorized } = useAuthManager();
    const metrika = useMetrikaService();

    return useCallback(() => {
        if (!isAuthorized) {
            return;
        }

        const params = {
            extraOriginParameters: {
                hashOrderId: nanoid(),
            },
        };

        metrika?.reachGoal('BUY_FILM_BUTTON_CLICK', params);
    }, [isAuthorized, metrika]);
};
